import 'react-dates/initialize' // to run react dates
import moment from 'moment'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import 'react-dates/lib/css/_datepicker.css'
import Image from 'react-bootstrap/lib/Image'
import Grid from 'react-bootstrap/lib/Grid'
import Row from 'react-bootstrap/lib/Row'
import Col from 'react-bootstrap/lib/Col'
import LocationDetails from '../components/LocationDetails'
import { chunks } from '../utils/array.js'
import { fetchLocations, showLocationDetails, fetchLocationDetails } from '../actions/locations.js'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import './Locations.css'
import {
  handleDateChange,
  updateDateFocus,
  hideLocationDetails
  // fetchUsersForCompany
} from '../actions/locations.js'
import { SingleDatePicker } from 'react-dates'
import 'react-dates/lib/css/_datepicker.css'

let hidden = null
let visibilityChange = null
if (typeof document.hidden !== 'undefined') {
  // Opera 12.10 and Firefox 18 and later support
  hidden = 'hidden'
  visibilityChange = 'visibilitychange'
} else if (typeof document.msHidden !== 'undefined') {
  hidden = 'msHidden'
  visibilityChange = 'msvisibilitychange'
} else if (typeof document.webkitHidden !== 'undefined') {
  hidden = 'webkitHidden'
  visibilityChange = 'webkitvisibilitychange'
}

class Locations extends Component {
  static defaultProps = {
    // focused: false,
    filterDate: moment()
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
    const { dispatch } = this.props
    let account = this.props.account
    dispatch(hideLocationDetails())
    if (account) {
      dispatch(fetchLocations(account._id))
    }
    document.addEventListener(visibilityChange, this.handleVisibilityChange, false)
  }

  selectLocation(location) {
    const { dispatch, account } = this.props
    dispatch(showLocationDetails(location))
    dispatch(fetchLocationDetails(location._id))
    if (location && location.building) {
      const buildingId = location.building._id
      // dispatch(fetchUsersForCompany(buildingId, account._id))
    }
  }

  handleDateChange(date) {
    fetchLocations
    const { dispatch } = this.props
    let filterDate = moment(date).startOf('day')
    if (filterDate.isValid()) {
      dispatch(handleDateChange(filterDate))
    }
  }

  updateDateFocus(focused) {
    const { dispatch } = this.props
    dispatch(updateDateFocus(focused.focused, false))
  }

  handleVisibilityChange = () => {
    if (document[hidden]) {
      const { dispatch } = this.props
      let account = this.props.account

      if (account) {
        dispatch(fetchLocations(account._id))
      }
    } else {
      const { dispatch } = this.props
      let account = this.props.account
      if (account) {
        dispatch(fetchLocations(account._id))
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener(visibilityChange, this.handleVisibilityChange)
  }

  render() {
    let fetchedLocations = this.props.fetchedLocations
    let rawLocations = this.props.locations
    let type = this.props.match.params.type
    var filterDate = this.props.filterDate ? moment(this.props.filterDate) : moment()

    let locations = rawLocations

    if (locations && locations.length > 0) {
      if (type === 'my_bookings') {
        locations = locations.filter((location) => {
          if (location.bookings) {
            let booking = location.bookings.find((booking) => {
              if (booking.user) {
                return moment(booking.startDate).isSame(filterDate, 'day') && booking.user._id === this.props.account._id
              }
            })

            if (booking) {
              return true
            }
          }

          return false
        })
      }

      locations = locations.filter((location) => {
        var bookable = false

        // check if location has available slots in filtered date
        var availableDate = location.availableDates.find((x) => {
          return moment(x.startDate).isSameOrBefore(filterDate) && moment(x.endDate).isSameOrAfter(filterDate)
        })
        if (availableDate) {
          //return true
          var timeslots = location.availableTimes.filter((x) => {
            var weekday = moment().day()
            if (x.weekday == moment().day()) {
              return true
            }
            return false
          })
          return timeslots.length > 0
        }
        return false
      })
    }

    if (fetchedLocations && locations && locations.length > 0) {
      locations.sort((location1, location2) => {
        var sort = 0
        if (location1.orderIndex > location2.orderIndex) {
          sort = 1
        } else if (location1.orderIndex < location2.orderIndex) {
          sort = -1
        }
        return sort
      })
      let organizedLocations = chunks(locations, 2)
      return (
        <div>
          <br />
          <Grid>
            <Row>
              <SingleDatePicker
                readOnly={true}
                openDirection='right'
                date={moment(this.props.filterDate)}
                onDateChange={this.handleDateChange.bind(this)}
                focused={this.props.focused}
                onFocusChange={this.updateDateFocus.bind(this)}
                id='filter_date'
              />
              <br />
              <br />
            </Row>
            {}
            {organizedLocations.map((row) => (
              <Row xs={12}>
                {row.map((location) => {
                  return (
                    <Col xs={12} sm={6} style={{ paddingLeft: '0px', paddingRight: '0px', margin: '0px' }}>
                      <div className='locationContainer' onClick={this.selectLocation.bind(this, location)}>
                        <div className='img-wrapper' style={{ width: '100%', height: '350px' }}>
                          <Image
                            style={{
                              height: '100%',
                              width: '100%',
                              objectFit: 'cover',
                              objectPosition: '50% 50%'
                            }}
                            sclass='rounded mx-auto d-block'
                            src={location.listImage}
                            responsive
                          />
                        </div>
                        <div className='content'>{location.name}</div>
                        <div className='rightDivider'>{}</div>
                        <div className='bottomDivider'>{}</div>
                        <div className='bottomDivider'>{}</div>
                        {/* <div className="locationDate">{moment(location.locationDate).format("MMM D")}</div> */}
                      </div>
                    </Col>
                  )
                })}
              </Row>
            ))}
          </Grid>
          <LocationDetails />
        </div>
      )
    } else {
      return (
        <div>
          <br />
          <Grid>
            <Row>
              <SingleDatePicker
                openDirection='right'
                date={moment(this.props.filterDate)}
                onDateChange={this.handleDateChange.bind(this)}
                focused={this.props.focused}
                onFocusChange={this.updateDateFocus.bind(this)}
                id='filter_date'
              />
              <br />
            </Row>
            <Row>
              <Col xs={12} sm={6} style={{ paddingLeft: '0px', paddingRight: '0px', margin: '0px' }}>
                <div className='container text-center' style={{ fontSize: '15px', paddingTop: '35px' }}>
                  {type == 'my_bookings' ? "You don't have any booked location at this date." : 'No locations available for booking at this date'}
                </div>
              </Col>
            </Row>
          </Grid>
          <LocationDetails />
        </div>
      )
    }
  }
}
const mapStateToProps = (state) => {
  return { ...state.locationsReducer, account: state.authReducer.account }
}

export default withRouter(connect(mapStateToProps)(Locations))



// WEBPACK FOOTER //
// ./src/components/Locations.js